export default __webpack_public_path__ + "static/media/payment-vodafone.f86bb7d7.svg";